// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Rate_wrapper__kQzQH","big":"Rate_big__4eudE","empty":"Rate_empty__vqlox"};